import { useEffect, useState } from 'react'

// since = Date.now() ตอนเริ่ม · null = ไม่นับ (คืน 0)
export default function useElapsedSeconds(since) {
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    if (!since) return undefined
    setNow(Date.now())
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [since])

  if (!since) return 0
  return Math.max(0, Math.floor((now - since) / 1000))
}
